import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import GoogleAnalyticsTracker from "./components/GoogleAnalyticsTracker";
import Home from "./pages/Home";
import About from "./pages/About";
import BrandProducts from "./pages/BrandProducts";
import ForManufacturers from "./pages/ForManufacturers";
import Contact from "./pages/Contact";

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <GoogleAnalyticsTracker />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products/:brandSlug" element={<BrandProducts />} />
            <Route path="/partner-with-us" element={<ForManufacturers />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsApp />
        <Toaster />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
